/* New footer sections start closed. Native disclosures own every later user choice. */
(() => {
  if (window.saberFooterInitialized) return;
  window.saberFooterInitialized = true;
  let installPrompt = null;
  let installed = navigator.standalone === true || matchMedia("(display-mode: standalone)").matches;
  function updateShortcuts() {
    document.querySelectorAll("[data-saber-home-shortcuts]").forEach((shortcuts) => {
      shortcuts.hidden = installed;
      shortcuts.querySelectorAll("[data-saber-install-prompt]").forEach((button) => {
        button.hidden = !installPrompt || installed;
      });
    });
  }
  window.addEventListener("beforeinstallprompt", (event) => {
    if (typeof event.prompt !== "function") return;
    event.preventDefault();
    installPrompt = event;
    updateShortcuts();
  });
  window.addEventListener("appinstalled", () => {
    installed = true;
    installPrompt = null;
    updateShortcuts();
  });
  document.addEventListener("click", async (event) => {
    const button = event.target.closest?.("[data-saber-install-prompt]");
    if (!button || !installPrompt) return;
    const prompt = installPrompt;
    installPrompt = null;
    updateShortcuts();
    const status = button.parentElement.querySelector("[data-saber-install-status]");
    try {
      await prompt.prompt();
      const choice = await prompt.userChoice;
      if (status) status.textContent = choice?.outcome === "accepted" ? status.dataset.installNext : status.dataset.installManual;
    } catch {
      if (status) status.textContent = status.dataset.installManual;
    }
    if (status) status.hidden = false;
  });
  // Native Shopify localization owns the language change. Preserve the current
  // product/view and fragment without intercepting or replacing its submission.
  document.addEventListener("submit", (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches("[data-saber-language-form]")) return;
    let destination = form.querySelector('input[name="return_to"]');
    if (!destination) {
      destination = document.createElement("input");
      destination.type = "hidden";
      destination.name = "return_to";
      form.append(destination);
    }
    const currentPath = location.pathname + location.search + location.hash;
    destination.value = currentPath.startsWith("/") && !currentPath.startsWith("//") ? currentPath : "/";
  });
  const initialized = new WeakSet();
  function initialize(root = document) {
    updateShortcuts();
    const groups = [...root.querySelectorAll("saber-footer-nav")];
    if (root.matches?.("saber-footer-nav")) groups.unshift(root);
    groups.forEach((navigation) => {
      if (initialized.has(navigation)) return;
      navigation.querySelectorAll(".ss-foot-group").forEach((panel) => {
        panel.open = false;
      });
      initialized.add(navigation);
    });
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", () => initialize(), {
      once: true,
    });
  else initialize();
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
})();
